import { render } from "./XacNhanThanhToan.vue?vue&type=template&id=7afbcc16&scoped=true"
import script from "./XacNhanThanhToan.vue?vue&type=script&lang=js"
export * from "./XacNhanThanhToan.vue?vue&type=script&lang=js"

import "./XacNhanThanhToan.vue?vue&type=style&index=0&id=7afbcc16&lang=scss&scoped=true"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7afbcc16"]])

export default __exports__